import { loadStripe } from '@stripe/stripe-js';
import BaseHttpService from './base-http.service';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export const initiateStripeCheckout = async () => {
  const stripe = await stripePromise;
  return stripe;
};

export default class PaymentService extends BaseHttpService {
  createCustomer(billingInfo) {
    const { email, name } = billingInfo;
    return this.post('stripe/create-customer',{email, name});
  }

  createSubscription( paymentMethodId, selectedPlan) {
    return this.post(`stripe/create-subscription`, {paymentId: paymentMethodId, priceId: selectedPlan});
  }

  cancelSubscription(userUuid) {
    return this.post(`stripe/cancel-subscription`);
  }
}